export default __webpack_public_path__ + "static/media/507.50175f1f.jpg";